import React from "react";
import { Target, Lightbulb } from "lucide-react";

export const PlayerReport = ({ report }) => (
  <section data-testid="player-step-report">
    <div className="grid gap-4 md:grid-cols-2">
      <Summary icon={Target} title="Objetivos" text={report.estrategia?.objetivos_generales} />
      <Summary icon={Target} title="Métricas y metas" text={report.metricas?.objetivos_numericos} />
    </div>
    <div className="mt-8 space-y-6">
      {(report.departamentos || []).map((d) => (
        <Department key={d.nombre} d={d} />
      ))}
    </div>
    {!!report.recomendaciones_consultor?.length && (
      <div className="mt-8 border border-slate-200 bg-white p-6" data-testid="player-recommendations">
        <p className="eyebrow flex items-center gap-1.5"><Lightbulb className="h-3 w-3" /> Recomendaciones del consultor</p>
        <ol className="mt-3 list-decimal space-y-2 pl-5 text-sm text-slate-700">
          {report.recomendaciones_consultor.map((r) => <li key={r.slice(0, 40)}>{r}</li>)}
        </ol>
      </div>
    )}
  </section>
);

const Summary = ({ icon: Icon, title, text }) => (
  <div className="border border-slate-200 bg-white p-5">
    <p className="eyebrow flex items-center gap-1.5"><Icon className="h-3 w-3" /> {title}</p>
    <p className="mt-2 text-sm leading-relaxed text-slate-700">{text || "—"}</p>
  </div>
);

const Department = ({ d }) => (
  <article className="border border-slate-200 bg-white" data-testid="player-department">
    <h3 className="border-b border-slate-100 bg-slate-900 px-5 py-3 font-display text-lg text-white">{d.nombre}</h3>
    <div className="grid gap-px bg-slate-100 md:grid-cols-2">
      {(d.personas || []).map((p) => (
        <div key={p.cargo} className="bg-white p-5">
          <p className="font-medium text-slate-900">{p.cargo}</p>
          <p className="text-xs text-slate-500">{p.nombre}</p>
          <ul className="mt-4 space-y-3">
            {(p.actividades || []).map((a) => <Activity key={a.nombre} a={a} />)}
          </ul>
        </div>
      ))}
    </div>
  </article>
);

const Activity = ({ a }) => (
  <li>
    <div className="flex items-baseline justify-between gap-3 text-sm">
      <span className="text-slate-700">{a.nombre}</span>
      <span className="font-display font-semibold text-slate-900">{a.peso}%</span>
    </div>
    <div className="mt-1 h-1.5 bg-slate-100">
      <div className="h-full bg-accent-blue" style={{ width: `${Math.min(100, a.peso)}%` }} />
    </div>
    <p className="mt-1 text-[11px] text-slate-500">
      {a.complejidad} complejidad · {(a.herramientas || []).slice(0, 3).join(", ")}
    </p>
  </li>
);
